import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import {  faPlus, faSearch, faEye } from '@fortawesome/free-solid-svg-icons';
import {  NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { PaymentAccountsService } from 'src/app/share/services/payment-account/payment-accounts.service';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-payment-account',
    templateUrl: './payment-account.component.html',
    styleUrls: ['./payment-account.component.scss'],
    standalone: false
})
export class PaymentAccountComponent implements OnInit, OnDestroy {

  protected faPlus = faPlus;
  protected faSearch = faSearch;
  protected faEye = faEye;

  @ViewChild('accountFormModal') accountFormModal!: TemplateRef<any>;

  mode: 'ADD' | 'VIEW'  = 'ADD';
  editAccountData: any = null;
  loader: boolean = false;
  errorMessage: string = '';
  page: number = 0;
  endOfResult: boolean = false;

  accountList: any[] = [];
  branches: any[] = [];
  toasterMsg: string = '';
  isBranchVisible: boolean = false;

  headingBottomLabel: string = '';
  cardTotalAccountsValue: number = 0;
  cardBranchesValue: number = 0;
  cardUnlinkedAccountsValue: number = 0;

  filters = {
    searchTerm: '',
    mode: null as string | null,
    branch: null as string | null
  };

  paymentModes = [
    { label: 'Cash', key: 'Cash' },
    { label: 'UPI', key: 'UPI' },
    { label: 'Bank Transfer', key: 'BankTransfer' },
    { label: 'Card', key: 'Card' },
    { label: 'Bajaj Finance', key: 'BajajFinance'}
  ];

  private offcanvasRef: any = null;
  private searchSubscription!: Subscription;
  private readonly searchSubject = new Subject<string>();

  constructor(
    private readonly offcanvasService: NgbOffcanvas,
    private readonly paymentAccountsService: PaymentAccountsService,
    private readonly companyService: CompanyServiceService,
    private readonly cmns: CommonServiceService,
    private readonly storageService: StorageService,
  ) {}

  ngOnInit(): void {
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
    if (this.isBranchVisible) {
      this.getBranches();
    }
    this.getAccounts();
    this.getPaymentAccountsHighlights();

    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.onFilterChange();
    });
  }

  getBranches(): void {
    this.companyService.getToCompanyList().subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.branches = (res.data || []).filter((c: any) => c.status === 'Active') || [];
          this.cardBranchesValue = this.branches.length;
        }
      },
    });
  }

  getPaymentAccountsHighlights() {
    this.paymentAccountsService.getAccountsHighlights().subscribe({
      next:(res: any) =>{
        let total = this.cmns.parseNumberOrZero(res?.data?.total);
        let active = this.cmns.parseNumberOrZero(res?.data?.active);
        let linked = this.cmns.parseNumberOrZero(res?.data?.withBalanceAccountId)
        this.headingBottomLabel = `${total} Accounts ${linked} Linked To Balance Accounts`
        this.cardTotalAccountsValue = active;
        if(total) this.cardUnlinkedAccountsValue = total - linked;
      }
    })
  }

  getPayload() {
    let payload: any = {
      page: this.page
    };
    if (this.filters.searchTerm) {
      payload.accountName = this.filters.searchTerm.trim();
    }
    if (this.filters.mode) {
      payload.paymentType = this.filters.mode;
    }
    if (this.filters.branch) {
      payload.company = this.filters.branch;
    }
    return payload
  }

  getAccounts(): void {
    if (this.loader || this.endOfResult) return;
    this.loader = true;
    this.errorMessage = '';
    const payload: any = this.getPayload()
    this.paymentAccountsService.getPaymentAccountList(payload).subscribe({
      next: (res: any) => {
        this.loader = false;
        const listData = res.data || [];
        this.accountList = payload.page == 0 ? listData : this.accountList.concat(listData);
        if (listData.length === 0 ) {
          this.endOfResult = true;
        }
      },
      error: (error: any) => {
        this.loader = false;
        this.errorMessage = error?.error?.error?.message || 'Failed to fetch payment accounts';
      }
    });
  }

  onFilterChange(): void {
    this.loader = false;
    this.page = 0;
    this.endOfResult = false;
    this.accountList = [];
    this.getAccounts();
  }

  onscrollTable(): void {
    if (this.endOfResult || this.loader) return;
    this.page++;
    this.getAccounts();
  }

  onSearchInput(): void {
    this.searchSubject.next(this.filters.searchTerm);
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) this.searchSubscription.unsubscribe();
    this.searchSubject.complete();
  }

  addNewAccount() {
    this.mode = 'ADD';
    this.editAccountData = null;

    this.offcanvasRef = this.offcanvasService.open(this.accountFormModal, {
      position: 'end',
      panelClass: 'payment-account-detail-offcanvas',
      backdrop: 'static',
      keyboard: false
    });
  }

  openAccountDetail(account: any) {
    this.mode = 'VIEW';
    this.editAccountData = account
    this.offcanvasRef = this.offcanvasService.open(this.accountFormModal, {
      position: 'end',
      panelClass: 'payment-account-detail-offcanvas',
      backdrop: 'static',
      keyboard: false
    });
  }

  onAccountSave(result: any) {
    this.toasterMsg = this.mode === 'ADD' ? 'New payment account created successfully' : 'Payment account edited successfully';
    this.offcanvasRef?.close();
    this.onFilterChange();
    this.getPaymentAccountsHighlights();
  }

  onFormCancel() {
    this.offcanvasRef?.dismiss();
    this.editAccountData = null;
  }

  
}
